// API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || "https://6hr1cnlc-3020.use2.devtunnels.ms",
  ENDPOINTS: {
    CASES: "/case",
    CASE_BY_ID: (id) => `/case/${id}`,
    CASE_FULL: (id) => `/case/${id}/full`,
    CASE_RELATED: (id) => `/case/${id}/related`,
    CATEGORIES:
      "/category?filter=isVisible%7C%7C%24eq%7C%7Ctrue&filter=isFeatured%7C%7C%24eq%7C%7Ctrue",
    ALL_CATEGORIES: "/category?filter=isVisible%7C%7C%24eq%7C%7Ctrue",
  },
  TIMEOUT: 10000, // 10 seconds
  RETRY_ATTEMPTS: 3,
};

// API Headers
export const getDefaultHeaders = () => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
});

// API Error Messages
export const API_ERROR_MESSAGES = {
  NETWORK_ERROR: 'Error de conexión. Verifica tu conexión a internet.',
  TIMEOUT_ERROR: 'La solicitud tardó demasiado en responder.',
  SERVER_ERROR: 'Error del servidor. Intenta más tarde.',
  NOT_FOUND: 'Recurso no encontrado.',
  UNAUTHORIZED: 'No tienes autorización para acceder a este recurso.',
  FORBIDDEN: 'Acceso prohibido.',
  VALIDATION_ERROR: 'Los datos enviados no son válidos.',
  UNKNOWN_ERROR: 'Error desconocido. Intenta más tarde.',
};
